import type { ApiError } from "@/shared/types/interfaces/Source";
import { useMutation } from "@tanstack/react-query";
import { GenerarEnlacePruebaVidaVU } from "../services/ApiConsultaGestionCasos/Vu.service";
import { HttpStatusCode } from "@/shared/types/enums/HttpStatusCode.enum";
import { customAlert } from "@/shared/components";
import type { GenerarEnlacePruebaVidaVURequest } from "../types/interfaces/AuntenticacionV2Vu";

export const useGenerarEnlacePruebaVidaVU = () => { 
    return useMutation<{ message: string }, ApiError, GenerarEnlacePruebaVidaVURequest>({
        mutationFn: GenerarEnlacePruebaVidaVU,
        onError: (error) => {
            console.error('Error al generar enlace de prueba de vida:', error);

            if (error.status === HttpStatusCode.BadRequest) {
                return customAlert({
                    icon: "error",
                    titulo: "<div class='text-2xl'>Error al generar enlace</div>",
                    mensaje: `<div class="flex justify-normal text-sm">${error.message}</div>`,
                });
            }

            customAlert({
                icon: "error",
                titulo: "<div class='text-2xl'>Error al generar enlace de prueba de vida</div>",
                mensaje: `<div class="flex justify-normal text-sm">Ocurrió un error inesperado al generar el enlace. Por favor, intente nuevamente más tarde.</div>`,
            });

        },
        onSuccess: (response) => {
            console.log('success GenerarEnlacePruebaVidaVU', response)
        }
    })
};